import React from 'react';
import { Grid } from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';

const Header: React.FC = () => {
  const description = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.discount:
        return (
          <Trans
            i18nKey="welcomePoints.getCoupon"
            defaults="You are about to get your welcome coupon"
          />
        );
      case WelcomeGiftTypes.points:
        return (
          <Trans
            i18nKey="welcomePoints.getPoints"
            defaults="You are about to get your welcome {{, gems}}"
            values={{}}
          />
        );
      default:
        return undefined;
    }
  }, [WelcomeGiftStore.type]);
  return (
    <Grid container direction="column" spacing={1}>
      <Grid>
        <Trans
          i18nKey="welcomePoints.missionCompleted"
          defaults="Mission completed"
        />
      </Grid>
      <Grid sx={{ fontSize: '1.4rem', fontWeight: 'normal' }}>
        {description}
      </Grid>
    </Grid>
  );
};

export default Header;
